import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgHeartFill = (props) => /* @__PURE__ */ _jsx("svg", {
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "m5.347 22.765 12.705 11.862a2.854 2.854 0 0 0 3.896 0l12.705-11.862a10.519 10.519 0 0 0 3.347-7.7v-.407a10.05 10.05 0 0 0-17.156-7.109L20 8.393l-.844-.844A10.05 10.05 0 0 0 2 14.658v.408c0 2.918 1.21 5.71 3.347 7.699Z" })
});
export default SvgHeartFill;
